module.exports = __webpack_public_path__ + "img/EGS_icon_01.fdff2863.svg";